<template>
    <div>
        <Table :columns="columns" :data="data">
            <template slot-scope="{ row, index }" slot="money">
                ¥ {{row.money}}元
            </template>
        </Table>
    </div>
</template>
<script>
  export default {
    name: 'clazz',
    data() {
      return {
        columns: [
          {
            title: '说明',
            key: 'remark',
            align: 'left'
          },
          {
            title: '校区',
            key: 'zoneName',
            align: 'left'
          },
          {
            title: '金额',
            slot: 'money',
            align: 'center',
            width:100
          },
          {
            title: '时间',
            key: 'createtime',
            align: 'center'
          }
        ],
        data: []
      }
    },
    methods: {
      getList(){
        this.$api.student.getFinRecordList({
          id:this.$route.query.id
        }).then(resp => {
          this.data = resp.data;
        });
      }
    },
    mounted() {
      this.getList();
    }
  }
</script>
